module.exports = __webpack_public_path__ + "static/media/mail-message-default.fbaa63ab.png";